module.exports = __webpack_public_path__ + "img/MLT.d4e8dba9.svg";